import React from "react";
import MicControl from "./controls/MicControl";
import CameraControl from "./controls/CameraControl";
import type { Device } from "../zoom/usePreviewAV";
import "../styles/videoFooter.scss";

type Props = {
  disabled?: boolean;
  isStartedAudio: boolean;
  isMuted: boolean;
  micList: Device[];
  speakerList: Device[];
  activeMicId?: string;
  activeSpeakerId?: string;
  onToggleAudio: () => void;
  onSelectAudio: (key: string) => void; // "microphone|id" or "speaker|id"
  isStartedVideo: boolean;
  cameraList: Device[];
  activeCameraId?: string;
  onToggleVideo: () => void;
  onSelectCamera: (id: string) => void;
};

export default function PreviewFooter(props: Props) {
  return (
    <div className="video-footer video-footer-waiting-room">
      <MicControl
        disabled={props.disabled}
        isStartedAudio={props.isStartedAudio}
        isMuted={props.isMuted}
        micList={props.micList}
        speakerList={props.speakerList}
        activeMicId={props.activeMicId}
        activeSpeakerId={props.activeSpeakerId}
        onToggle={props.onToggleAudio}
        onSelect={props.onSelectAudio}
      />

      <CameraControl
        disabled={props.disabled}
        isStartedVideo={props.isStartedVideo}
        cameraList={props.cameraList}
        activeCameraId={props.activeCameraId}
        showMirror={false}  // preview mode: keep simple for now
        showBlur={false}    // preview mode: keep simple for now
        onToggle={props.onToggleVideo}
        onSelectCamera={props.onSelectCamera}
      />
    </div>
  );
}
